// Swiper 8
// import Swiper, {
//     Navigation,
//     Pagination
// } from 'swiper';

// #overlay

export class SwpProd {
  constructor() {
    this.swiperProd = {};
    this.swiperProdThumbs = [];
    this.swiperLarge = {};
    this.swiperNotice = {};
    this.body = {};
  }

  init() {
    if (document.getElementById('overlay')) {
      const overlayElem = document.getElementById('overlay').querySelectorAll('.overlay-clickarea')[0];
      overlayElem.addEventListener('click', () => {
        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('is-zoom-photo');
      });
    }


    // --------------
    // 商品拡大写真swiper
    if (document.getElementById('js-swiper-prod-large')) {
      const swiperLargeElem = document.getElementById('js-swiper-prod-large');

      //close btn
      if (swiperLargeElem.querySelectorAll('.swiper-icon-close')[0]) {
        const zoomBtn = swiperLargeElem.querySelectorAll('.swiper-icon-close')[0];
        zoomBtn.addEventListener('click', () => {
          const body = document.getElementsByTagName('body')[0];
          body.classList.remove('is-zoom-photo');
        });
      }

      // 商品拡大写真swiper
      this.swiperLarge = new Swiper('#js-swiper-prod-large', {
        autoplay: false,
        speed: 500,
        effect: 'slide',
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // thumbs: {
        //     swiper: this.swiperProd
        // },
      });
    }

    // --------------
    // 商品swiper + サムネイル
    if (document.getElementById('js-swiper-prod')) {

      const swiperProdElem = document.getElementById('js-swiper-prod');
      swiperProdElem.myTargetSwiper = this.swiperLarge;

      // サムネイル
      if (swiperProdElem.parentElement.querySelectorAll('.Slider-swiper__thumbs')[0]) {
        this.swiperProdThumbs = swiperProdElem.parentElement.querySelectorAll('.Slider-swiper__thumbs .Slider-swiper__thumb');
      }

      // 商品swiper
      this.swiperProd = new Swiper('#js-swiper-prod', {
        autoplay: false,
        speed: 500,
        effect: 'slide',
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // thumbs: {
        //     swiper: this.swiperLarge
        // },
        on: {
          init: function () {
            //console.log(this.el);

            if (this.el.parentElement.querySelectorAll('.Slider-swiper__thumbs')[0]) {
              let thumbs = this.el.parentElement.querySelectorAll('.Slider-swiper__thumbs .Slider-swiper__thumb');
              //console.log(thumbs);

              thumbs[0].classList.add('selected');
              for (let j = 0; j < thumbs.length; j++) {
                thumbs[j].addEventListener('click', () => {
                  this.slideTo(j + 1);
                  for (let k = 0; k < thumbs.length; k++) {
                    if (j == k) {
                      thumbs[k].classList.add('selected');
                    } else {
                      thumbs[k].classList.remove('selected');
                    }
                  }
                });
              }
            }

            // zoom btn
            if (this.el.querySelectorAll('.swiper-icon-zoom')[0]) {
              const zoomBtn = this.el.querySelectorAll('.swiper-icon-zoom')[0];
              zoomBtn.addEventListener('click', () => {
                const body = document.getElementsByTagName('body')[0];
                body.classList.add('is-zoom-photo');

                console.log(this.realIndex);
                this.el.myTargetSwiper.slideToLoop(this.realIndex, 10);
              });
            }

            //close btn
            // if (this.el.querySelectorAll('.swiper-icon-close')[0]) {
            //     const zoomBtn = this.el.querySelectorAll('.swiper-icon-close')[0];
            //     zoomBtn.addEventListener('click', () => {
            //         const body = document.getElementsByTagName('body')[0];
            //         body.classList.remove('is-zoom-photo');
            //     });
            // }

          },
          slideChange: function () {
            if (this.el.parentElement.querySelectorAll('.Slider-swiper__thumbs')[0]) {
              let thumbs = this.el.parentElement.querySelectorAll('.Slider-swiper__thumbs .Slider-swiper__thumb');
              for (let j = 0; j < thumbs.length; j++) {
                if (j == this.realIndex) {
                  thumbs[j].classList.add('selected');
                } else {
                  thumbs[j].classList.remove('selected');
                }
              }
            }
            // if (document.getElementById('js-swiper-prod-large')) {
            //     const swiperLargeElem = document.getElementById('js-swiper-prod-large');
            // }
          }
        }
      });

    }


    // -------------- 
    // Header-notice
    if (document.querySelectorAll('.js-header-notice')[0]) {
      this.swiperNotice = new Swiper('.js-header-notice', {
        autoplay: false,
        speed: 800, //Duration of transition between slides
        effect: 'fade',
        loop: true,
        on: {
          init: function () {
            this.autoplay.delay = 1800;
            this.autoplay.start();
          }
        }
      });
    }


  }

  // getRealIndex(num) {
  //     console.log(this.swipers[num]['swiper']);
  //     return 1; //this.swipers[num]['swiper'].progress;
  // }

}